import React, { useState, useEffect } from "react";
import iconAndroid from "../../assets/images/home/android.webp";
import iconApple from "../../assets/images/home/apple.webp";
import img_qrGooglePlay from "../../assets/images/qrGooglePlay.png";
import img_qrChinaAndroid from "../../assets/images/qrChinaAndroid.png";
import img_qriOS from "../../assets/images/qriOS.png";
import { useTranslation } from "react-i18next";
import DownloadCard from "../Home/DownItem/DownItem";
import "./Download.css";

function Download() {
  const { t } = useTranslation();
  const [activeQR, setActiveQR] = useState(null);
  const [inviteCode, setInviteCode] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("invite");
    if (code) {
      setInviteCode(code);
      console.log("获取到邀请码:", code);
    }
  }, []);

  const copyToClipboard = (text) => {
    if (!text) return;
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard
        .writeText(text)
        .then(() => console.log("邀请码已复制:", text))
        .catch((err) => console.error("复制失败:", err));
    } else {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      console.log("邀请码已复制（兼容模式）:", text);
    }
  };

  const handleDownloadClick = (type) => {
    copyToClipboard(inviteCode);
    if (type === "ios") {
      window.location.href = `https://apps.apple.com/app/id6736935182`;
    } else if (type === "android") {
      window.location.href = `https://play.google.com/store/apps/details?id=com.tombuildsai.expopractice`;
    } else if (type === "android-cn") {
      window.location.href = `https://apk.ikiai.org/app-latest.apk`;
    }
  };

  const platforms = [
    {
      id: "ios",
      title: t("home.download.ios"),
      icon: iconApple,
      qr: img_qriOS,
      onClick: () => handleDownloadClick("ios"),
    },
    {
      id: "android",
      title: t("home.download.android"),
      icon: iconAndroid,
      qr: img_qrGooglePlay,
      onClick: () => handleDownloadClick("android"),
    },
    {
      id: "android-cn",
      title: t("home.download.android-cn"),
      icon: iconAndroid,
      qr: img_qrChinaAndroid,
      onClick: () => handleDownloadClick("android-cn"),
    },
    // {
    //   id: "discord",
    //   title: "Discord",
    //   icon: iconDiscord,
    //   qr: img_qrDiscord,
    //   onClick: () => window.open("https://discord.gg/a8GXTmtMZe", "_blank"),
    // },
  ];

  const steps = [
    {
      id: 1,
      title: t("download_page.step1_title"),
      desc: t("download_page.step1_desc"),
      sub: t("download_page.step1_sub"),
    },
    {
      id: 2,
      title: t("download_page.step2_title"),
      desc: t("download_page.step2_desc"),
      sub: t("download_page.step2_sub"),
    },
    {
      id: 3,
      title: t("download_page.step3_title"),
      desc: t("download_page.step3_desc"),
      sub: t("download_page.step3_sub"),
    },
  ];

  return (
    <div className="download-page">
      <div className="download-section">
        <h1 className="main-title global-subtitle">{t("download_page.title")}</h1>
        <p className="subtitle global-text">{t("download_page.subtitle")}</p>

        <div className="platform-grid">
          {platforms.map((platform) => (
            <DownloadCard
              key={platform.id}
              icon={platform.icon}
              title={platform.title}
              qrCode={platform.qr}
              onClick={platform.onClick}
            />
          ))}
        </div>
      </div>

      {/* <div className="divider-container">
        <div className="dashed-divider"></div>
      </div> */}

      <div className="next-steps-section">
        <h2 className="section-title global-subtitle">{t("download_page.next_title")}</h2>
        <div className="steps-grid">
          {steps.map((step) => (
            <div key={step.id} className="step-card">
              <span className="step-label global-subtitle">{step.title}</span>
              <h3 className="step-label global-subtitle">{step.desc}</h3>
              <p className="step-desc global-text">{step.sub}</p>
            </div>
          ))}
        </div>
      </div>

      {activeQR && (
        <div className="qr-overlay" onClick={() => setActiveQR(null)}>
          <div className="qr-modal" onClick={(e) => e.stopPropagation()}>
            <img src={activeQR} alt="QR Code" />
            <button className="close-btn" onClick={() => setActiveQR(null)}>✕</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Download;
